import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { User } from '../../models/user.model';

import { SnotifyService } from 'ng-snotify';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private router: Router, private notifier: SnotifyService) {}
  private _token: string;
  private authSubject = new BehaviorSubject(false);
  private roleSubject = new BehaviorSubject('guest');
  private _user: User;
  authChange = this.authSubject.asObservable();
  roleChange = this.roleSubject.asObservable();

  login(token: string, user: User, role: RoleType) {
    this.setToken(token);
    this.setRole(role);
    this.setUser(user);
    this.router.navigate(['/dashboard']);
    this.authSubject.next(true);
  }

  logout() {
    localStorage.clear();
    // if (redirect) {
    this.router.navigate(['/login']);
    // }
    this.authSubject.next(false);
  }

  sessionExpired() {
    localStorage.clear();
    this.authSubject.next(false);
    this.router.navigate(['/login']);
    this.notifier.error('Authentication session expired');
  }

  duplicateLogin() {
    localStorage.clear();
    this.authSubject.next(false);
    this.router.navigate(['/login']);
    this.notifier.error(
      `You've been logged in from another device, please re-login`
    );
  }

  isAuthenticated() {
    if (!this.authSubject.value && Boolean(localStorage.getItem('token'))) {
      this.authSubject.next(true);
    }
    return this.authSubject.value;
  }

  getRefreshTokenRequestBody() {
    if (this.user) {
      return {
        uuid: this.user.uuid,
        refreshToken: this.user.refreshToken
      };
    }
  }

  refreshLoggedInToken(token, user) {
    this.setToken(token);
    this.setUser(user);
  }

  get role() {
    if (!localStorage.getItem('role')) {
      this.roleSubject.next('guest');
    } else if (localStorage.getItem('role') !== this.roleSubject.value) {
      this.roleSubject.next(localStorage.getItem('role'));
    }
    return this.roleSubject.value;
  }

  private setRole(role) {
    this.roleSubject.next(role);
    localStorage.setItem('role', role);
  }

  get user() {
    if (this._user) {
      return this._user;
    } else if (localStorage.getItem('user')) {
      this._user = JSON.parse(localStorage.getItem('user'));
      return this._user;
    } else {
      return null;
    }
  }

  private setUser(user) {
    this._user = user;
    localStorage.setItem('user', JSON.stringify(user));
  }

  get token() {
    if (this._token) {
      return this._token;
    } else if (localStorage.getItem('token')) {
      this._token = localStorage.getItem('token');
      return this._token;
    } else {
      return null;
    }
  }

  private setToken(token) {
    this._token = token;
    localStorage.setItem('token', token);
  }
}

export type RoleType = 'Admin' | 'Local' | 'Traveler';
